import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

// Layout Components
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import LeistungenPage from "@/pages/LeistungenPage";
import LeistungDetailPage from "@/pages/LeistungDetailPage";
import EinsatzgebietePage from "@/pages/EinsatzgebietePage";
import EinsatzgebietDetailPage from "@/pages/EinsatzgebietDetailPage";
import UeberUnsPage from "@/pages/UeberUnsPage";
import RatgeberPage from "@/pages/RatgeberPage";
import RatgeberDetailPage from "@/pages/RatgeberDetailPage";
import KontaktPage from "@/pages/KontaktPage";
import FAQPage from "@/pages/FAQPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="App">
      <Header />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Startseite */}
        <Route path="/" element={<Layout><HomePage /></Layout>} />
        
        {/* Leistungen */}
        <Route path="/leistungen" element={<Layout><LeistungenPage /></Layout>} />
        <Route path="/leistungen/:slug" element={<Layout><LeistungDetailPage /></Layout>} />
        
        {/* Einsatzgebiete */}
        <Route path="/einsatzgebiete" element={<Layout><EinsatzgebietePage /></Layout>} />
        <Route path="/einsatzgebiete/:slug" element={<Layout><EinsatzgebietDetailPage /></Layout>} />
        
        {/* Über uns */}
        <Route path="/ueber-uns" element={<Layout><UeberUnsPage /></Layout>} />
        
        {/* Ratgeber */}
        <Route path="/ratgeber" element={<Layout><RatgeberPage /></Layout>} />
        <Route path="/ratgeber/:slug" element={<Layout><RatgeberDetailPage /></Layout>} />
        
        {/* Kontakt */}
        <Route path="/kontakt" element={<Layout><KontaktPage /></Layout>} />
        
        {/* FAQ */}
        <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
        
        {/* Rechtliches */}
        <Route path="/impressum" element={<Layout><ImpressumPage /></Layout>} />
        <Route path="/datenschutz" element={<Layout><DatenschutzPage /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
